export default __webpack_public_path__ + "static/media/team-cc.fea19aca.jpg";